import { useSignups } from "Signups/state";
import { useLocation } from "react-router-dom";

export default function useDisplayFamilyReg() {
  const [state] = useSignups();
  const hasFamilyReg =
    state?.hasFamilyRegistration && state?.canViewFamilyRegistrationAdminPanel;
  const location = useLocation();
  const isFamilyRegPage = location.pathname === "/signups/family-registration";

  return hasFamilyReg && isFamilyRegPage;
}
